import { Alert } from '@/components/Alert';
import { BodySmall, HeaderXSmall } from '@/components/Typography';
import { useScreenWidth } from '@/hooks';

export const CoverageRequirementsAlert = () => {
  const { isDesktop } = useScreenWidth();

  return (
    <Alert
      severity="info"
      iconPosition="start"
      sx={{ mb: 3 }}
      dataTestId="coverage-requirements-alert"
    >
      <HeaderXSmall
        sx={{
          lineHeight: isDesktop ? '24px !important' : '22px !important',
          fontSize: isDesktop ? '16px' : '14px !important',
        }}
        data-testid="coverage-requirements-alert-title"
      >
        Information on coverage requirements
      </HeaderXSmall>
      <BodySmall
        data-testid="coverage-requirements-alert-message"
        sx={{
          color: 'text.primary',
          lineHeight: isDesktop ? '24px !important' : '20px !important',
          fontSize: isDesktop ? '16px' : '14px !important',
          fontWeight: isDesktop ? 400 : 600,
        }}
      >
        Your company default for Rent and Deposit Coverage will be automatically applied to this
        deal and coverage cannot be customized.
      </BodySmall>
    </Alert>
  );
};
